import { makeFilterParams } from '../../utils/helpers/helpers';
import httpClient from '../httpClient';

const getProjects = async (params) => {
  return await httpClient.get('/product_approval_selectors/projects/', {
    params: params,
  });
};

const getRoles = async (params) => {
  return await httpClient.get('/product_approval_selectors/roles/', {
    params: params,
  });
};

const getTerms = async (params) => {
  return await httpClient.get('/product_approval_selectors/terms/', {
    params: params,
  });
};

const getMassIDs = async (params) => {
  return await httpClient.get('/product_approval_selectors/mass_ctm/', {
    params: params,
  });
};

const get = async (id) => {
  return await httpClient.get(`/product_approval/${id}/`);
};

const getRealValue = async (id) => {
  return await httpClient.get(`/product_approval/${id}/real_value/`);
};

const ajaxTable = async (
  query = '',
  page = 1,
  pageSize = 10,
  _sortBy = '-created_at',
  search = false,
  exportCSV = false,
) => {
  let searchBy = '';

  if (search) searchBy = '&filter[search]=' + search;

  if (exportCSV)
    return await httpClient.get(`product_approval/export${query}${searchBy}`, {
      responseType: 'blob',
    });
  else
    return await httpClient.get(
      `product_approval${query}&page[number]=${page}&page[size]=${pageSize}${searchBy}`,
    );
};

const contractorTable = async (
  query = {},
  page = 1,
  pageSize = 10,
  _sortBy = '-created_at',
  search = false,
  _exportCSV = false,
) => {
  return await httpClient.get(`pa_contractor_search/`, {
    params: Object.assign(
      {},
      makeFilterParams(query).params,
      {
        'page[number]': page,
        'page[size]': pageSize,
      },
      search ? { 'filter[search]': search } : {},
    ),
  });
};

const paymentsTable = async (
  query = '',
  page = 1,
  pageSize = 10,
  _sortBy = '-created_at',
  search = false,
  exportCSV = false,
) => {
  if (exportCSV)
    return await httpClient.get(`pa_payment/export/`, {
      responseType: 'blob',
      params: Object.assign(
        {},
        {
          'filter[contrato]': query,
          'page[number]': page,
          'page[size]': pageSize,
        },
        search ? { 'filter[search]': search } : {},
      ),
    });
  else
    return await httpClient.get(`pa_payment/`, {
      params: Object.assign(
        {},
        {
          'filter[contrato]': query,
          'page[number]': page,
          'page[size]': pageSize,
        },
        search ? { 'filter[search]': search } : {},
      ),
    });
};

const getProducts = async (id) => await httpClient.get(`pa_payment/${id}/`);

const add_units = async (id, data) =>
  await httpClient.patch(`pa_payment/${id}/add_units/`, data);

const remove_units = async (id, data) =>
  await httpClient.patch(`pa_payment/${id}/remove_units/`, data);

const get_units = async (id, product_id) =>
  await httpClient.get(`pa_payment/${id}/get_units/`, {
    params: { 'filter[producto]': product_id },
  });

const add_payment = async (id) =>
  await httpClient.patch(`product_approval/${id}/add_payment/`);

const finalize_pending = async (id) =>
  await httpClient.put(`product_approval/${id}/postcontractual_finalize/`);

const save_payment = async (id, data) =>
  await httpClient.put(`pa_payment/${id}/`, data);

const send_payment = async (id, data) =>
  await httpClient.patch(`pa_payment/${id}/send_payment/`, data);

export {
  getProjects,
  getRoles,
  getTerms,
  getMassIDs,
  ajaxTable,
  contractorTable,
  paymentsTable,
  get,
  getProducts,
  add_units,
  remove_units,
  get_units,
  add_payment,
  save_payment,
  send_payment,
  finalize_pending,
  getRealValue,
};
